import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TelegramIcon from "@mui/icons-material/Telegram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

/** Same networks on the contact card and in the footer, in this order. */
export function socialLinks(contacts) {
  return [
    contacts?.facebook && { href: contacts.facebook, label: "Facebook", Icon: FacebookIcon },
    contacts?.instagram && { href: contacts.instagram, label: "Instagram", Icon: InstagramIcon },
    contacts?.telegram && { href: contacts.telegram, label: "Telegram", Icon: TelegramIcon },
    contacts?.whatsapp && { href: contacts.whatsapp, label: "WhatsApp", Icon: WhatsAppIcon },
  ].filter(Boolean);
}
